import cn from "../../lib/classnames";
import React from "react";
import styles from "./ReviewLabel.module.css";

type Props = React.ComponentProps<"label"> & {
    label: string;
};

export default function ReviewLabel({label, className, ...rest}: Props) {
    return (
        <label className={cn(styles.container, className)} {...rest}>
            {label}
        </label>
    );
}
